import { DEFAULT_IMAGE_HEIGHT, DEFAULT_IMAGE_WIDTH } from '~/constant'
import ProjectImageAsset from '~/models/ProjectData/ProjectImageAsset'

export const correctAssetWidthNHeight = assets => {
  assets.forEach(asset => {
    if (asset instanceof ProjectImageAsset) {
      let defaultWidth = DEFAULT_IMAGE_WIDTH
      let defaultHeight = DEFAULT_IMAGE_HEIGHT
      if (asset.layerId) {
        defaultHeight = asset.height > 0
          ? asset.height
          : (asset.settings?.originalSize?.height || 0)
        defaultWidth = asset.width > 0
          ? asset.width
          : (asset.settings?.originalSize?.width || 0)
        // eslint-disable-next-line no-param-reassign
        asset.width = defaultWidth
        // eslint-disable-next-line no-param-reassign
        asset.height = defaultHeight
      }
    }
  })
}
